export default __webpack_public_path__ + "static/media/portfolio3.cbab4255.jpg";